var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('el-dialog', {
    attrs: {
      "title": "Edit Quotation",
      "close-on-click-modal": false,
      "visible": _vm.visible,
      "width": "1650px",
      "append-to-body": "",
      "top": "2vh"
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.visible = $event;
      }
    }
  }, [_c('el-form', {
    ref: "dataForm",
    attrs: {
      "model": _vm.dataForm,
      "label-width": "0",
      "size": "mini"
    }
  }, [_c('div', {
    staticClass: "wdb100 quotationWrap"
  }, [_vm.dataForm.contentList.length == 0 ? _c('el-button', {
    staticClass: "mb10",
    attrs: {
      "type": "primary",
      "size": "small",
      "plain": "",
      "icon": "el-icon-plus"
    },
    on: {
      "click": function click($event) {
        _vm.dataForm.contentList.push(JSON.parse(JSON.stringify(_vm.contentObj)));
      }
    }
  }, [_vm._v(" Add Item ")]) : _vm._e(), _vm._l(_vm.dataForm.contentList, function (parent, index) {
    return _c('div', {
      key: "parent".concat(index),
      staticClass: "shadeWrap"
    }, [_c('el-row', {
      staticClass: "pt10 pb16 fxRow borderTop billingTop",
      attrs: {
        "gutter": 16
      }
    }, [_c('el-col', {
      staticClass: "tac",
      attrs: {
        "span": 1
      }
    }, [_c('span', {
      staticClass: "fs18 cursor-pointer blue el-icon-circle-plus-outline",
      on: {
        "click": function click($event) {
          _vm.dataForm.contentList.splice(index + 1, 0, JSON.parse(JSON.stringify(_vm.contentObj)));
        }
      }
    }), _c('span', {
      staticClass: "fs18 ml8 cursor-pointer red el-icon-remove-outline",
      on: {
        "click": function click($event) {
          return _vm.dataForm.contentList.splice(index, 1);
        }
      }
    })]), _c('el-col', {
      staticClass: "flex align-center",
      attrs: {
        "span": 3
      }
    }, [_c('span', {
      staticClass: "billingTo"
    }, [_vm._v("Client Code:")]), _c('el-form-item', {
      ref: "contentList.".concat(index, ".clientCode"),
      refInFor: true,
      staticClass: "wdb100",
      attrs: {
        "prop": "contentList.".concat(index, ".clientCode")
      }
    }, [_c('client-code-select-remote-search', {
      staticClass: "text-left",
      attrs: {
        "showItems": ['companyName', 'billingAddresses'],
        "placeholder": "Select"
      },
      on: {
        "change-item": function changeItem(data) {
          return _vm.clientCodeChange(data, parent);
        }
      },
      model: {
        value: parent.clientCode,
        callback: function callback($$v) {
          _vm.$set(parent, "clientCode", $$v);
        },
        expression: "parent.clientCode"
      }
    })], 1)], 1), _c('el-col', {
      staticClass: "flex align-center",
      attrs: {
        "span": 7
      }
    }, [_c('span', {
      staticClass: "billingTo"
    }, [_vm._v("Billing to:")]), _c('el-form-item', {
      ref: "contentList.".concat(index, ".companyTitle"),
      refInFor: true,
      staticClass: "wdb100",
      attrs: {
        "prop": "contentList.".concat(index, ".companyTitle"),
        "rules": {
          required: true,
          message: 'please enter',
          trigger: 'submit'
        }
      }
    }, [_c('el-input', {
      staticClass: "text-left",
      attrs: {
        "placeholder": "Billing to"
      },
      model: {
        value: parent.companyTitle,
        callback: function callback($$v) {
          _vm.$set(parent, "companyTitle", $$v);
        },
        expression: "parent.companyTitle"
      }
    })], 1)], 1), _c('el-col', {
      staticClass: "flex align-center",
      attrs: {
        "span": 6
      }
    }, [_c('span', {
      staticClass: "billingTo"
    }, [_vm._v("Address:")]), _c('el-form-item', {
      staticClass: "wdb100",
      attrs: {
        "prop": "contentList.".concat(index, ".companyAddress")
      }
    }, [_c('el-input', {
      staticClass: "text-left",
      attrs: {
        "placeholder": "Address"
      },
      model: {
        value: parent.companyAddress,
        callback: function callback($$v) {
          _vm.$set(parent, "companyAddress", $$v);
        },
        expression: "parent.companyAddress"
      }
    })], 1)], 1), _c('el-col', {
      staticClass: "flex align-center",
      attrs: {
        "span": 4
      }
    }, [_c('span', {
      staticClass: "billingTo"
    }, [_vm._v("Country:")]), _c('el-form-item', {
      staticClass: "wdb100",
      attrs: {
        "prop": "contentList.".concat(index, ".companyCountry")
      }
    }, [_c('el-select', {
      staticClass: "wdb100 text-left",
      attrs: {
        "placeholder": "Select",
        "filterable": ""
      },
      model: {
        value: parent.companyCountry,
        callback: function callback($$v) {
          _vm.$set(parent, "companyCountry", $$v);
        },
        expression: "parent.companyCountry"
      }
    }, _vm._l(_vm.countryList, function (item) {
      return _c('el-option', {
        key: "country-".concat(index, "-").concat(item.value),
        attrs: {
          "label": item.title,
          "value": item.value
        }
      });
    }), 1)], 1)], 1), _c('el-col', {
      staticClass: "flex align-center",
      attrs: {
        "span": 3
      }
    }, [_c('span', {
      staticClass: "billingTo"
    }, [_vm._v("Code:")]), _c('el-form-item', {
      staticClass: "wdb100",
      attrs: {
        "prop": "contentList.".concat(index, ".companyPostalCode")
      }
    }, [_c('el-input', {
      staticClass: "text-left",
      attrs: {
        "placeholder": "Code"
      },
      model: {
        value: parent.companyPostalCode,
        callback: function callback($$v) {
          _vm.$set(parent, "companyPostalCode", $$v);
        },
        expression: "parent.companyPostalCode"
      }
    })], 1)], 1)], 1), _c('el-row', {
      staticClass: "pt10 pb16 fxRow borderTop billingTop",
      attrs: {
        "gutter": 16
      }
    }, [_c('el-col', {
      attrs: {
        "span": 1
      }
    }), _c('el-col', {
      staticClass: "flex align-center",
      attrs: {
        "span": 7
      }
    }, [_c('span', {
      staticClass: "billingTo"
    }, [_vm._v("Supplier:")]), _c('el-form-item', {
      ref: "contentList.".concat(index, ".supplierId"),
      refInFor: true,
      staticClass: "wdb100",
      attrs: {
        "prop": "contentList.".concat(index, ".supplierId"),
        "rules": {
          required: true,
          message: 'please select',
          trigger: 'submit'
        }
      }
    }, [_c('el-select', {
      staticClass: "wdb100 tal",
      on: {
        "change": function change() {
          parent.invoiceTemplateId = null;
          parent.bankAccountIds = [];
        }
      },
      model: {
        value: parent.supplierId,
        callback: function callback($$v) {
          _vm.$set(parent, "supplierId", $$v);
        },
        expression: "parent.supplierId"
      }
    }, _vm._l(_vm.supplierList, function (item) {
      return _c('el-option', {
        key: "supplier-".concat(index, "-").concat(item.id),
        attrs: {
          "label": item.companyName,
          "value": item.id
        }
      });
    }), 1)], 1)], 1), _c('el-col', {
      staticClass: "flex align-center",
      attrs: {
        "span": 7
      }
    }, [_c('span', {
      staticClass: "billingTo"
    }, [_vm._v("Invoice Template:")]), _c('el-form-item', {
      staticClass: "wdb100",
      attrs: {
        "prop": "contentList.".concat(index, ".invoiceTemplateId"),
        "rules": {
          required: true,
          message: 'please select',
          trigger: 'submit'
        }
      }
    }, [parent.supplierId ? [_c('el-select', {
      staticClass: "wdb100 tal",
      attrs: {
        "placeholder": "Select Invoice Template"
      },
      on: {
        "change": function change() {
          parent.bankAccountIds = [];
        }
      },
      model: {
        value: parent.invoiceTemplateId,
        callback: function callback($$v) {
          _vm.$set(parent, "invoiceTemplateId", $$v);
        },
        expression: "parent.invoiceTemplateId"
      }
    }, _vm._l(_vm.invoiceTemplateOptions(parent), function (item) {
      return _c('el-option', {
        key: "invoiceTemplate-".concat(index, "-").concat(item.id),
        attrs: {
          "label": item.templateName,
          "value": item.id
        }
      });
    }), 1)] : _c('p', {
      staticClass: "fs12 black88"
    }, [_vm._v("Select supplier first")])], 2)], 1), _c('el-col', {
      staticClass: "flex align-center",
      attrs: {
        "span": 9
      }
    }, [_c('span', {
      staticClass: "billingTo"
    }, [_vm._v("Bank Accounts:")]), _c('el-form-item', {
      staticClass: "wdb100",
      attrs: {
        "prop": "contentList.".concat(index, ".bankAccountIds"),
        "rules": {
          type: 'array',
          required: true,
          message: 'please select',
          trigger: 'submit'
        }
      }
    }, [parent.invoiceTemplateId ? [_c('div', {
      staticClass: "crp fs12",
      on: {
        "click": function click($event) {
          return _vm.selectBankAccountHandle(parent, index);
        }
      }
    }, [parent.bankAccountIds.length > 0 ? _c('p', {
      staticClass: "fs12 blue"
    }, [_vm._v(" " + _vm._s(_vm.getBankAccountTags(parent)) + " ")]) : _c('p', {
      staticClass: "fs12 blue"
    }, [_vm._v("Select Bank Account")])])] : _c('p', {
      staticClass: "fs12 black88"
    }, [_vm._v("Select invoice template first")])], 2)], 1)], 1), _c('div', {
      staticClass: "billingTitle"
    }, [_c('el-row', {
      staticClass: "pt10 pb10 fxRow borderTop",
      attrs: {
        "gutter": 10
      }
    }, [_c('el-col', {
      attrs: {
        "span": 1
      }
    }), _c('el-col', {
      attrs: {
        "span": 4
      }
    }, [_c('p', {
      staticClass: "fs12 fwb tac"
    }, [_vm._v("Fee Schedule")])]), _c('el-col', {
      attrs: {
        "span": 3
      }
    }, [_c('p', {
      staticClass: "fs12 fwb tac"
    }, [_vm._v("Covered Period")])]), _c('el-col', {
      attrs: {
        "span": 2
      }
    }, [_c('p', {
      staticClass: "fs12 fwb tac"
    }, [_vm._v("Amount")])]), _c('el-col', {
      attrs: {
        "span": 2
      }
    }, [_c('p', {
      staticClass: "fs12 fwb wbbw tac"
    }, [_vm._v("Incl. Third Party Fee")])]), _c('el-col', {
      attrs: {
        "span": 4
      }
    }, [_c('p', {
      staticClass: "fs12 fwb tac"
    }, [_vm._v("Note For Third Party")])]), _c('el-col', {
      attrs: {
        "span": 2
      }
    }, [_c('p', {
      staticClass: "fs12 fwb wbbw tac"
    }, [_vm._v("Incl. Other Fee")])]), _c('el-col', {
      attrs: {
        "span": 3
      }
    }, [_c('p', {
      staticClass: "fs12 fwb tac"
    }, [_vm._v("Note For Other Fee")])]), _c('el-col', {
      attrs: {
        "span": 3
      }
    }, [_c('p', {
      staticClass: "fs12 fwb tac"
    }, [_vm._v("Payment Due Date")])])], 1)], 1), _vm._l(parent.partList, function (sub, idx) {
      return _c('div', {
        key: "sub".concat(idx),
        staticClass: "billingPart"
      }, [_vm._l(sub.itemList, function (grand, ids) {
        return _c('div', {
          key: "grand".concat(ids),
          staticClass: "billingContent"
        }, [_c('el-row', {
          staticClass: "pt10 pb16 fxRow borderTop",
          attrs: {
            "gutter": 10
          }
        }, [_c('el-col', {
          staticClass: "tac",
          attrs: {
            "span": 1
          }
        }, [_c('span', {
          staticClass: "fs18 cursor-pointer blue el-icon-circle-plus-outline",
          on: {
            "click": function click($event) {
              sub.itemList.splice(ids + 1, 0, JSON.parse(JSON.stringify(_vm.itemObj)));
            }
          }
        }), ids != 0 ? _c('span', {
          staticClass: "fs18 ml8 cursor-pointer red el-icon-remove-outline",
          on: {
            "click": function click($event) {
              return sub.itemList.splice(ids, 1);
            }
          }
        }) : _vm._e()]), _c('el-col', {
          attrs: {
            "span": 4
          }
        }, [_c('el-form-item', {
          ref: "contentList.".concat(index, ".partList.").concat(idx, ".itemList.").concat(ids, ".title"),
          refInFor: true,
          attrs: {
            "prop": "contentList.".concat(index, ".partList.").concat(idx, ".itemList.").concat(ids, ".title"),
            "rules": {
              required: true,
              message: 'please enter',
              trigger: 'submit'
            }
          }
        }, [_c('el-autocomplete', {
          staticClass: "wdb100",
          attrs: {
            "fetch-suggestions": function fetchSuggestions(queryString, cb) {
              return _vm.titleQuerySearch(queryString, cb, parent.supplierId);
            },
            "placeholder": "Title Of Charges"
          },
          model: {
            value: grand.title,
            callback: function callback($$v) {
              _vm.$set(grand, "title", $$v);
            },
            expression: "grand.title"
          }
        })], 1)], 1), _c('el-col', {
          staticClass: "flex align-center justify-center",
          attrs: {
            "span": 3
          }
        }, [_c('el-form-item', {
          ref: "contentList.".concat(index, ".partList.").concat(idx, ".itemList.").concat(ids, ".startDate"),
          refInFor: true,
          attrs: {
            "prop": "contentList.".concat(index, ".partList.").concat(idx, ".itemList.").concat(ids, ".startDate"),
            "rules": {
              required: true,
              message: 'please select',
              trigger: 'submit'
            }
          }
        }, [_c('el-date-picker', {
          staticClass: "wd104",
          attrs: {
            "type": "date",
            "value-format": "yyyy-MM-dd",
            "placeholder": "Start Date"
          },
          model: {
            value: grand.startDate,
            callback: function callback($$v) {
              _vm.$set(grand, "startDate", $$v);
            },
            expression: "grand.startDate"
          }
        })], 1), _c('span', {
          staticClass: "ml2 mr2"
        }, [_vm._v("~")]), _c('el-form-item', {
          ref: "contentList.".concat(index, ".partList.").concat(idx, ".itemList.").concat(ids, ".endDate"),
          refInFor: true,
          attrs: {
            "prop": "contentList.".concat(index, ".partList.").concat(idx, ".itemList.").concat(ids, ".endDate"),
            "rules": {
              required: true,
              message: 'please select',
              trigger: 'submit'
            }
          }
        }, [_c('el-date-picker', {
          staticClass: "wd104",
          attrs: {
            "type": "date",
            "value-format": "yyyy-MM-dd",
            "placeholder": "End Date"
          },
          model: {
            value: grand.endDate,
            callback: function callback($$v) {
              _vm.$set(grand, "endDate", $$v);
            },
            expression: "grand.endDate"
          }
        })], 1)], 1), _c('el-col', {
          attrs: {
            "span": 2
          }
        }, [_c('el-form-item', {
          ref: "contentList.".concat(index, ".partList.").concat(idx, ".itemList.").concat(ids, ".amount"),
          refInFor: true,
          attrs: {
            "prop": "contentList.".concat(index, ".partList.").concat(idx, ".itemList.").concat(ids, ".amount"),
            "rules": {
              required: true,
              message: 'please enter',
              trigger: 'submit'
            }
          }
        }, [_c('el-input', {
          directives: [{
            name: "minusPoint2",
            rawName: "v-minusPoint2"
          }],
          staticClass: "amountInput",
          attrs: {
            "placeholder": "0.00"
          },
          model: {
            value: grand.amount,
            callback: function callback($$v) {
              _vm.$set(grand, "amount", $$v);
            },
            expression: "grand.amount"
          }
        })], 1)], 1), _c('el-col', {
          attrs: {
            "span": 2
          }
        }, [_c('el-form-item', {
          ref: "contentList.".concat(index, ".partList.").concat(idx, ".itemList.").concat(ids, ".thirdPartyFee"),
          refInFor: true,
          attrs: {
            "prop": "contentList.".concat(index, ".partList.").concat(idx, ".itemList.").concat(ids, ".thirdPartyFee"),
            "rules": {
              required: true,
              message: 'please enter',
              trigger: 'submit'
            }
          }
        }, [_c('el-input', {
          directives: [{
            name: "minusPoint2",
            rawName: "v-minusPoint2"
          }],
          staticClass: "amountInput",
          attrs: {
            "placeholder": "0.00"
          },
          model: {
            value: grand.thirdPartyFee,
            callback: function callback($$v) {
              _vm.$set(grand, "thirdPartyFee", $$v);
            },
            expression: "grand.thirdPartyFee"
          }
        })], 1)], 1), _c('el-col', {
          attrs: {
            "span": 4
          }
        }, [_c('el-form-item', {
          ref: "contentList.".concat(index, ".partList.").concat(idx, ".itemList.").concat(ids, ".noteForThirdParty"),
          refInFor: true,
          attrs: {
            "prop": "contentList.".concat(index, ".partList.").concat(idx, ".itemList.").concat(ids, ".noteForThirdParty"),
            "rules": {
              required: true,
              message: 'please select',
              trigger: 'submit'
            }
          }
        }, [_c('el-autocomplete', {
          staticClass: "wdb100",
          attrs: {
            "fetch-suggestions": _vm.thirdPartyQuerySearch,
            "placeholder": "Note For Third Party"
          },
          model: {
            value: grand.noteForThirdParty,
            callback: function callback($$v) {
              _vm.$set(grand, "noteForThirdParty", $$v);
            },
            expression: "grand.noteForThirdParty"
          }
        })], 1)], 1), _c('el-col', {
          attrs: {
            "span": 2
          }
        }, [_c('el-form-item', {
          ref: "contentList.".concat(index, ".partList.").concat(idx, ".itemList.").concat(ids, ".otherFee"),
          refInFor: true,
          attrs: {
            "prop": "contentList.".concat(index, ".partList.").concat(idx, ".itemList.").concat(ids, ".otherFee"),
            "rules": {
              required: true,
              message: 'please enter',
              trigger: 'submit'
            }
          }
        }, [_c('el-input', {
          directives: [{
            name: "minusPoint2",
            rawName: "v-minusPoint2"
          }],
          staticClass: "amountInput",
          attrs: {
            "placeholder": "0.00"
          },
          model: {
            value: grand.otherFee,
            callback: function callback($$v) {
              _vm.$set(grand, "otherFee", $$v);
            },
            expression: "grand.otherFee"
          }
        })], 1)], 1), _c('el-col', {
          attrs: {
            "span": 3
          }
        }, [_c('el-form-item', {
          ref: "contentList.".concat(index, ".partList.").concat(idx, ".itemList.").concat(ids, ".noteForOther"),
          refInFor: true,
          attrs: {
            "prop": "contentList.".concat(index, ".partList.").concat(idx, ".itemList.").concat(ids, ".noteForOther"),
            "rules": {
              required: true,
              message: 'please select',
              trigger: 'submit'
            }
          }
        }, [_c('el-autocomplete', {
          staticClass: "wdb100",
          attrs: {
            "fetch-suggestions": _vm.otherQuerySearch,
            "placeholder": "Note For Other Fee"
          },
          model: {
            value: grand.noteForOther,
            callback: function callback($$v) {
              _vm.$set(grand, "noteForOther", $$v);
            },
            expression: "grand.noteForOther"
          }
        })], 1)], 1), _c('el-col', {
          attrs: {
            "span": 3
          }
        })], 1)], 1);
      }), _c('div', {
        staticClass: "billingBrief"
      }, [_c('el-row', {
        staticClass: "pt10 pb16 fxRow borderTop borderBottom",
        attrs: {
          "gutter": 10
        }
      }, [_c('el-col', {
        staticClass: "tac",
        attrs: {
          "span": 1
        }
      }, [_c('span', {
        staticClass: "fs18 cursor-pointer blue el-icon-circle-plus-outline",
        on: {
          "click": function click($event) {
            parent.partList.splice(idx + 1, 0, JSON.parse(JSON.stringify(_vm.partObj)));
          }
        }
      }), idx != 0 ? _c('span', {
        staticClass: "fs18 ml8 cursor-pointer red el-icon-remove-outline",
        on: {
          "click": function click($event) {
            return parent.partList.splice(idx, 1);
          }
        }
      }) : _vm._e()]), _c('el-col', {
        attrs: {
          "span": 4
        }
      }, [_c('el-form-item', {
        ref: "contentList.".concat(index, ".partList.").concat(idx, ".subTotalDesp"),
        refInFor: true,
        attrs: {
          "prop": "contentList.".concat(index, ".partList.").concat(idx, ".subTotalDesp"),
          "rules": {
            required: true,
            message: 'please enter',
            trigger: 'submit'
          }
        }
      }, [_c('el-input', {
        attrs: {
          "placeholder": "Text description of subtotals"
        },
        model: {
          value: sub.subTotalDesp,
          callback: function callback($$v) {
            _vm.$set(sub, "subTotalDesp", $$v);
          },
          expression: "sub.subTotalDesp"
        }
      })], 1)], 1), _c('el-col', {
        attrs: {
          "span": 3
        }
      }), _c('el-col', {
        staticClass: "tac",
        attrs: {
          "span": 2
        }
      }, [_c('p', {
        staticClass: "fs12 lh16 pb2"
      }, [_vm._v("Subtotal")]), _c('p', {
        staticClass: "fs12 fwb lh16 orange newline"
      }, [_vm._v(_vm._s(_vm.currencySymbolFormat(_vm.getBillingCurrency(parent))) + _vm._s(_vm.subtotalAmountSum(sub)))])]), _c('el-col', {
        staticClass: "tac",
        attrs: {
          "span": 2
        }
      }, [_c('p', {
        staticClass: "fs12 lh16 pb2"
      }, [_vm._v("Subtotal")]), _c('p', {
        staticClass: "fs12 fwb lh16 orange newline"
      }, [_vm._v(_vm._s(_vm.currencySymbolFormat(_vm.getBillingCurrency(parent))) + _vm._s(_vm.subTotalThirdPartyFeeSum(sub)))])]), _c('el-col', {
        attrs: {
          "span": 4
        }
      }), _c('el-col', {
        staticClass: "tac",
        attrs: {
          "span": 2
        }
      }, [_c('p', {
        staticClass: "fs12 lh16 pb2"
      }, [_vm._v("Subtotal")]), _c('p', {
        staticClass: "fs12 fwb lh16 orange newline"
      }, [_vm._v(_vm._s(_vm.currencySymbolFormat(_vm.getBillingCurrency(parent))) + _vm._s(_vm.subTotalOtherFeeSum(sub)))])]), _c('el-col', {
        staticClass: "fs12 tac",
        attrs: {
          "span": 3
        }
      }, [_c('p', {
        staticClass: "fwb"
      }, [_vm._v("Is it a down payment?")]), _c('el-form-item', {
        ref: "contentList.".concat(index, ".partList.").concat(idx, ".isDownPayment"),
        refInFor: true,
        attrs: {
          "prop": "contentList.".concat(index, ".partList.").concat(idx, ".isDownPayment"),
          "rules": {
            required: true,
            message: 'please select',
            trigger: 'submit'
          }
        }
      }, [_c('el-radio-group', {
        on: {
          "change": function change($event) {
            sub.paymentDueTime = null;
          }
        },
        model: {
          value: sub.isDownPayment,
          callback: function callback($$v) {
            _vm.$set(sub, "isDownPayment", $$v);
          },
          expression: "sub.isDownPayment"
        }
      }, [_c('el-radio', {
        attrs: {
          "label": 1
        }
      }, [_vm._v("Yes")]), _c('el-radio', {
        attrs: {
          "label": 0
        }
      }, [_vm._v("No")])], 1)], 1)], 1), _c('el-col', {
        attrs: {
          "span": 3
        }
      }, [sub.isDownPayment == 1 ? _c('p', {
        staticClass: "fs12 tac lh16"
      }, [_vm._v("Payable upon submission")]) : _vm._e(), sub.isDownPayment == 0 ? _c('el-form-item', {
        ref: "contentList.".concat(index, ".partList.").concat(idx, ".paymentDueTime"),
        refInFor: true,
        attrs: {
          "prop": "contentList.".concat(index, ".partList.").concat(idx, ".paymentDueTime"),
          "rules": {
            required: true,
            message: 'please select',
            trigger: 'submit'
          }
        }
      }, [_c('el-date-picker', {
        staticClass: "wdb100",
        attrs: {
          "type": "date",
          "value-format": "yyyy-MM-dd HH:mm:ss",
          "placeholder": "Payment due date"
        },
        model: {
          value: sub.paymentDueTime,
          callback: function callback($$v) {
            _vm.$set(sub, "paymentDueTime", $$v);
          },
          expression: "sub.paymentDueTime"
        }
      })], 1) : _vm._e()], 1)], 1), _c('div', {
        staticClass: "wdb100 hg40"
      })], 1)], 2);
    }), _c('div', {
      staticClass: "billingBottom"
    }, [_c('el-row', {
      staticClass: "pt10 pb10 fxRow borderTop borderBottom",
      attrs: {
        "gutter": 10
      }
    }, [_c('el-col', {
      attrs: {
        "span": 1
      }
    }), _c('el-col', {
      attrs: {
        "span": 4
      }
    }, [_c('el-form-item', {
      ref: "contentList.".concat(index, ".sumTotalDesp"),
      refInFor: true,
      attrs: {
        "prop": "contentList.".concat(index, ".sumTotalDesp"),
        "rules": {
          required: true,
          message: 'please enter',
          trigger: 'submit'
        }
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "The literal description of the total"
      },
      model: {
        value: parent.sumTotalDesp,
        callback: function callback($$v) {
          _vm.$set(parent, "sumTotalDesp", $$v);
        },
        expression: "parent.sumTotalDesp"
      }
    })], 1)], 1), _c('el-col', {
      attrs: {
        "span": 3
      }
    }), _c('el-col', {
      attrs: {
        "span": 2
      }
    }, [_c('p', {
      staticClass: "fs12 tac lh16 pb2"
    }, [_vm._v("Total")]), _c('p', {
      staticClass: "fs12 tac lh16 fwb orange newline"
    }, [_vm._v(_vm._s(_vm.currencySymbolFormat(_vm.getBillingCurrency(parent))) + _vm._s(_vm.sumTotalPriceSum(parent)))])]), _c('el-col', {
      attrs: {
        "span": 2
      }
    }, [_c('p', {
      staticClass: "fs12 tac lh16 pb2"
    }, [_vm._v("Total")]), _c('p', {
      staticClass: "fs12 tac lh16 fwb orange newline"
    }, [_vm._v(" " + _vm._s(_vm.currencySymbolFormat(_vm.getBillingCurrency(parent))) + _vm._s(_vm.sumTotalThirdPartyFeeSum(parent)) + " ")])]), _c('el-col', {
      attrs: {
        "span": 4
      }
    }), _c('el-col', {
      attrs: {
        "span": 2
      }
    }, [_c('p', {
      staticClass: "fs12 tac lh16 pb2"
    }, [_vm._v("Total")]), _c('p', {
      staticClass: "fs12 tac lh16 fwb orange newline"
    }, [_vm._v(_vm._s(_vm.currencySymbolFormat(_vm.getBillingCurrency(parent))) + _vm._s(_vm.sumTotalOtherFeeSum(parent)))])]), _c('el-col', {
      attrs: {
        "span": 3
      }
    }), _c('el-col', {
      attrs: {
        "span": 3
      }
    })], 1)], 1)], 2);
  })], 2)]), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function click($event) {
        _vm.visible = false;
      }
    }
  }, [_vm._v("Cancel")]), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.submitLoading
    },
    on: {
      "click": _vm.dataFormSubmit
    }
  }, [_vm._v("OK")])], 1)], 1), _c('select-bank-account', {
    ref: "selectBankAccountRef",
    on: {
      "updateBankAccountIds": _vm.updateBankAccountIds
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }